import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const links: Record<string, string> = {
  search: '/infoTrac/reverse-mail-tracking/search-result',
};

const path = 'oldPages/reverseMail/index.html';

function ReverseMailTracking() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const create = iframeDocument.getElementById('searchBtn');

      if (create) {
        create.addEventListener('click', () => navigate(links.search));
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <iframe ref={iframeRef} title="reverseMailTracking" src={path} className="flex-grow border-none" />
    </div>
  );
}

export default ReverseMailTracking;
